var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "200px",
    height: "200.00px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M796 279.9L620.6 455.3c-14 14-36.9 14-50.9 0s-14-36.9 0-50.9L745.1 229c14-14 36.9-14 50.9 0s14 36.9 0 50.9z",
    fill: "#515151"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M796 481H581.5c-20.2 0-36.5-16.4-36.5-36.5V228.7c0-20.3 16.5-37.1 36.7-36.7 19.5 0.4 35.3 16.4 35.3 36v166.3c0 8.1 6.6 14.7 14.7 14.7h163.5c20.3 0 37.1 16.4 36.7 36.7-0.3 19.6-16.3 35.3-35.9 35.3zM228 744.1l175.4-175.4c14-14 36.9-14 50.9 0s14 36.9 0 50.9L278.9 795c-14 14-36.9 14-50.9 0s-14-36.9 0-50.9z",
    fill: "#515151"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M228 543h214.3c20.3 0 36.7 16.4 36.7 36.7v215.5c0 20.3-16.5 37.1-36.7 36.7-19.5-0.4-35.3-16.4-35.3-36V615H228.7c-20.3 0-37.1-16.4-36.7-36.7 0.4-19.6 16.4-35.3 36-35.3z",
    fill: "#515151"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M189.3 135.9c-29.7 0-53.8 24.1-53.8 53.7v644.7c0 29.7 24.1 53.7 53.8 53.7h645.4c29.7 0 53.8-24.1 53.8-53.7V189.6c0-29.7-24.1-53.7-53.8-53.7H189.3z m-13-71.1h671.5c61.8 0 111.9 50.1 111.9 111.8v670.8c0 61.7-50.1 111.8-111.9 111.8H176.3c-61.8 0-111.9-50-111.9-111.8V176.6c0-61.7 50.1-111.8 111.9-111.8z m0 0",
    fill: "#515151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom-in.bade7d90f5502ffa9e7d940a3eef84fe.svg";
export { ForwardRef as ReactComponent };